import { deleteFromScope } from '@edicom/common/parser/deleteFromScope';

/**
 * Prepara el scope angularjs con el formBuilder y el binding de CAB etc...
 * para poder compilar directivas angularjs en las celdas de edición,
 * (o las celdas tipo object cuando solo son renderer para que muestra y compila el popup)
 */
export function initScopeAngularjs() {
  // recuperamos el scope del ec-grid-edit
  const $scope = this.scope.$parent;

  this.resetValue = resetValue.bind(this);

  // $scope.ecFormBuilderController y $scope.xPath vienen de fb-grid
  // $scope.ecFormBuilderController.bind(this.scope, $scope.xPath); // @odeniel no podemos porque no existe LIN en scope padre a veces (viene del current del ec-grid2)

  // hacemos el bind: scope.CAB
  $scope.ecFormBuilderController.bindData(this.scope);

  // copiamos el `$scope.ecFormBuilderController` en el scope de la celda (por ej. para ec-attachment del frontend)`
  this.scope.ecFormBuilderController = $scope.ecFormBuilderController;

  // hacemos el bind: scope.LIN
  const registerName = $scope.xPath.split('.').pop(); // Recuperamos "LIN" de "CAB.LIN"
  this.scope[registerName] = this.data; // copiamos el 'current' LIN en el scope

  const model = `${registerName}.${this.model}`; // Concatenamos "LIN" delante del campo para completar el modelo

  // init scope para fb-grid-popup.directive.js
  this.scope.tabToNextCell = this.api.grid.tabToNextCell;
  this.scope.tabToPreviousCell = this.api.grid.tabToPreviousCell;

  this.scope.resetValue = this.resetValue;

  /**
   * Metodo que borra (delete) el campo del objeto linea.
   * Hace por ejemplo un `delete scope.LIN.REFERENCIA`
   */
  function resetValue() {
    if (!this.scope) {
      return;
    }

    deleteFromScope(this.scope, model, { isImmutable: false });
    this.scope.$evalAsync();
  }
}
